// extracted by mini-css-extract-plugin
export default {"containerForm":"Form_containerForm__Gc+2x","form":"Form_form__RPAUL"};